import Modal from 'component/hoc/modal/Modal';
import React, { useRef } from 'react';
import UserForm from './userForm/UserForm';
import styles from './NewUserModal.module.scss';
import { usePost } from 'hooks/usePost';
import { useFetch } from 'hooks/useFetch';
import { userEndpoints } from 'hooks/endpoints';

const NewUserModal = ({
  isOpen,
  onClose,
  setRefetch,
  refetch,
  id,
  setSelectedUser,
}) => {
  const { mutate: AddUser, isPending: isAdding } = usePost();
  const { mutate: EditUser, isPending: isUpdating } = usePost();
  const formRef = useRef();

  const { data: data, isFetching: isFetching } = useFetch(
    ['userDetailsById', id],
    userEndpoints?.getUserById(id),
    {
      enabled: id != null,
    }
  );

  return (
    <Modal
      title='New User'
      isOpen={isOpen}
      onClose={onClose}
      classname={styles['modal-container']}
      modalContent={{
        component: (
          <UserForm
            AddUser={AddUser}
            formRef={formRef}
            onClose={onClose}
            setRefetch={setRefetch}
            refetch={refetch}
            id={id}
            setSelectedUser={setSelectedUser}
            data={data}
            isFetching={isFetching}
            EditUser={EditUser}
          />
        ),
      }}
      onSubmit={() => formRef.current?.handleSubmit()}
      footerComponent={<></>}
    />
  );
};

export default NewUserModal;
